import { render, staticRenderFns } from "./RatioCard.vue?vue&type=template&id=190d08c8&scoped=true"
import script from "./RatioCard.vue?vue&type=script&lang=js"
export * from "./RatioCard.vue?vue&type=script&lang=js"
import style0 from "./RatioCard.vue?vue&type=style&index=0&id=190d08c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d08c8",
  null
  
)

export default component.exports